// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const NotificationsOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M16.38 74.5c8.77-11.686 9.756-28.845 9.827-30.384C28.13 28.075 36.274 18.5 48 18.5c11.727 0 19.87 9.575 21.793 25.616.07 1.539 1.057 18.698 9.827 30.384H16.38Zm31.62 9c-3.164 0-5.842-2.112-6.705-5h13.41c-.863 2.888-3.541 5-6.705 5Zm37.406-8.422c-10.643-10.52-11.611-31.001-11.62-31.206a2.656 2.656 0 0 0-.011-.154c-1.882-15.871-9.768-26.444-21.022-28.742.146-.47.247-.958.247-1.476a5 5 0 1 0-10 0c0 .518.102 1.006.247 1.476-11.254 2.298-19.14 12.871-21.021 28.742-.006.051-.01.103-.012.154-.01.205-.977 20.686-11.62 31.206A1.999 1.999 0 0 0 12 78.5h25.192c.943 5.112 5.426 9 10.808 9s9.865-3.888 10.809-9h25.19a2 2 0 0 0 1.407-3.422Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default NotificationsOutline;
